import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const useAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Log the page view
        logEvent(analytics, 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            page_path: location.pathname
        });
    }, [location]);
};

export default useAnalytics; 